import React from 'react';
import StripeCheckout from 'react-stripe-checkout';

const StripeCheckoutButton = ({ price }) => {
  const priceForStripe = price * 100;
  const publishableKey = 'pk_test_51KmdrfSI5LzBUtsYbgtkCaBk65KJYuNmneEp9ALkZnHz48P1aWcGfL4sxLVSHhcSBo9MAqjSWuLauAACt9wBhjEG00qGDZdf6p';

  const onToken = token => {
    console.log(token);
    alert('Payment Succesful!');
  };

  return (
    <StripeCheckout
      label='Pay Now'
      name='Fashionera'
      billingAddress
      shippingAddress
      image='https://www.freeiconspng.com/thumbs/letter-f-icon-png/blue-round-letter-f-icon-png-11.png'
      description={`Your total is $${price}`}
      amount={priceForStripe}
      panelLabel='Pay Now'
      token={onToken}
      stripeKey={publishableKey}
    />
  );
};

export default StripeCheckoutButton;